import React, { Component } from 'react';
import { connect } from 'react-redux';
import { resolveLocalizedText } from '../../../../utils';
import { ChangeContactView } from '../../components/ChangeContactView';
import { goto } from '../../../../actions/historyActions';
import Step from '@axa-asia/emma-stylesheet/lib/components/Step/Step';
import { stringFormatter } from '../../../../utils';
import Group from '../../../../assets/images/cic-gra-7.png';
import {
  getChangeMobileLabels,
  getChangeMobileStepContext,
  getTransactionId,
  getSelectedList,
} from '../../selectors/updateMobileSelector';
import { getSelectedPolicy } from '../../selectors/changeContactSelector';
import './style.scss';
import _ from 'lodash';
import { contactPermissionPolicy } from '../../types/changeContactService';
import { ENTITY_CODE } from '../../../../constants/constants';
import {
  trackUpdateContactSuccess,
  TrackUpdateContactSuccessAction,
  TrackUpdateContactSuccessContent,
} from '../../../../utils/generalGaEventAnalytics';

export interface UpdateMobileConfirmContainerProps {
  changeMobileLabels: any;
  changeMobileStepContext: any;
  policyDetails: any;
  selectedList: contactPermissionPolicy[];
  transactionId: string;
  isUpdate: boolean;
}

export interface UpdateMobileConfirmContainerState {}

export class UpdateMobileConfirmContainer extends Component<
  UpdateMobileConfirmContainerProps,
  UpdateMobileConfirmContainerState
> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { policyDetails, isUpdate } = this.props;
    if (_.isEmpty(policyDetails)) {
      goto('emma-change-contact', undefined, undefined, true);
    }

    if (isUpdate) {
      trackUpdateContactSuccess(
        TrackUpdateContactSuccessContent.MOBILE,
        TrackUpdateContactSuccessAction.UPDATE,
      );
    } else {
      trackUpdateContactSuccess(
        TrackUpdateContactSuccessContent.MOBILE,
        TrackUpdateContactSuccessAction.ADD,
      );
    }
  }

  onGoNext = () => {
    // const backIndex = getHistoryIndexById(CHANGE_CONTACT_ID);
    // historyGo(backIndex);
    goto('emma-change-contact');
  };

  render() {
    const {
      policyDetails,
      selectedList,
      changeMobileLabels,
      changeMobileStepContext,
      transactionId,
    } = this.props;
    const {
      editMobileTitle,
      confirmTitle,
      confirmTransactionId,
      viewProfileBtn,
    } = changeMobileLabels;
    const resolvedStepContext = resolveLocalizedText(
      changeMobileStepContext,
    ) as any;
    const FilterPolicyList = [policyDetails, ...selectedList].filter(
      (policy) => policy,
    );
    const hasLife = FilterPolicyList.some(
      (policy) => policy.entityCode === ENTITY_CODE.LHK,
    );
    const hasEb = FilterPolicyList.some(
      (policy) => policy.entityCode === ENTITY_CODE.EHK,
    );
    const daysForProcess = hasLife ? 8 : 6;
    let confirmStepContext: any = resolveLocalizedText(
      changeMobileLabels.confirmStepContext,
    );
    const stepList =
      hasLife || hasEb
        ? confirmStepContext.list
        : confirmStepContext.list.slice(0, 2);
    confirmStepContext = {
      list: stepList.map((step: any) => ({
        item: stringFormatter(step.item, {
          daysForProcess: `${daysForProcess}` || '',
        }),
      })),
    };

    return (
      <div className="change-mobile-confirm">
        <ChangeContactView
          pageName={
            editMobileTitle ? resolveLocalizedText(editMobileTitle) : ''
          }
          stepContext={resolvedStepContext}
          activeIndex={4}
          hideBackButton
        >
          <div className="emma-stylesheet-grid-system">
            <div className="change-mobile-confirm-icon">
              <img src={Group} />
            </div>
            <div className="change-mobile-confirm-heading">
              {confirmTitle ? resolveLocalizedText(confirmTitle) : ''}
            </div>
            {/* <div className="change-mobile-confirm-transaction-id">
              {confirmTransactionId ? stringFormatter(resolveLocalizedText(confirmTransactionId), {
                transactionId
              }) : ''}
            </div> */}
            <div className="change-mobile-confirm-step">
              <Step context={confirmStepContext} />
            </div>
            <div className="row">
              <button
                className="change-mobile-confirm-button emma-stylesheet-primary-default-button"
                data-enable-ga
                data-ga-type="button"
                onClick={this.onGoNext}
              >
                {viewProfileBtn ? resolveLocalizedText(viewProfileBtn) : ''}
              </button>
            </div>
          </div>
        </ChangeContactView>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const changeMobileLabels = getChangeMobileLabels(state);
    const changeMobileStepContext = getChangeMobileStepContext(state);
    const policyDetails = getSelectedPolicy(state);
    const transactionId = getTransactionId(state);
    const selectedList = getSelectedList(state);

    return {
      changeMobileLabels,
      changeMobileStepContext,
      policyDetails,
      transactionId,
      selectedList,
      isUpdate: !!policyDetails.mobileText,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {};
  }
}

export default connect(
  UpdateMobileConfirmContainer.mapStateToProps,
  UpdateMobileConfirmContainer.mapDispatchToProps,
)(UpdateMobileConfirmContainer);
